import { useEffect, useRef } from 'react';
import { Download, FileCode, X } from 'lucide-react';
import { artFile, formatDate, type Artwork, type DesignAsset } from './catalog';

export function ArtworkDialog({ art, assets, onClose }: { art: Artwork | null; assets: DesignAsset[]; onClose: () => void }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (!art) return;
    const dialog = ref.current;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog?.showModal();
    return () => { dialog?.close(); document.body.style.overflow = previous; };
  }, [art]);
  return <dialog ref={ref} className="art-library-dialog" aria-labelledby="art-library-dialog-title" onClose={onClose} onClick={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    {art && <div className="art-library-dialog__body">
      <button className="art-library-close" type="button" autoFocus aria-label="Fechar visualização" title="Fechar visualização" onClick={onClose}><X size={22} /></button>
      <img className="art-library-full-image" src={artFile(art, 'png')} alt={art.title} />
      <div className="art-library-dialog__info">
        <h2 id="art-library-dialog-title">{art.title}</h2>
        <p>{formatDate(art.createdAt)} · {art.format.replace('x', ' × ')} px</p>
        <div className="art-library-downloads">
          <a href={artFile(art, 'png')} download={`${art.id}.png`}><Download size={17} aria-hidden="true" />PNG</a>
          <a href={artFile(art, 'jpg')} download={`${art.id}.jpg`}><Download size={17} aria-hidden="true" />JPEG</a>
          <a href={artFile(art, 'source')} download={art.files.source}><FileCode size={17} aria-hidden="true" />Original</a>
        </div>
        <h3>Assets utilizados</h3>
        <ul>{art.assets.map((file) => <li key={file}>{assets.find((asset) => asset.file === file)?.title ?? file}</li>)}</ul>
      </div>
    </div>}
  </dialog>;
}
